
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Label from 'components/Label'
import NumberFormat from 'components/NumberFormat'
import DayTime from 'components/DayTime'

export default class ChartTooltipList extends React.PureComponent {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        color: PropTypes.string,
        value: PropTypes.number
      })
    ),
    date: PropTypes.instanceOf(Date),
    format: PropTypes.oneOf([
      'signed-number',
      'number',
      'decimal',
      'signed-percent',
      'percent',
      'doublePercent',
      'currency',
      'seconds',
      'decimalDouble'
    ])
  }

  static defaultProps = {
    format: 'number',
    items: []
  }

  render() {
    const {items, date} = this.props

    return (
      <div className='channels-data-list'>
        <DayTime date={date} className='channels-data-list_date' />
        {items.map((item, index) => (
          <div className='channels-data-list_item' key={index}>
            <Label color={item.color} className='channels-data-list_label'>
              {item.label}
            </Label>
            {this.renderValue(item.value)}
          </div>
        ))}
      </div>
    )
  }

  renderValue = value => {
    const {format} = this.props

    return <NumberFormat value={value} format={format} />
  }
}



// WEBPACK FOOTER //
// ./client/components/ChartTooltipList/index.js